var _ellipse, _path, _path2, _path3, _path4, _path5, _rect, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContract({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 50,
    viewBox: "0 0 51 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 25.1534,
    cy: 25,
    rx: 25.0582,
    ry: 25,
    fill: "#006FF5",
    fillOpacity: 0.25
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1031 15.2941H30.6958",
    stroke: "#006FF5",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1031 19.7059H30.6958",
    stroke: "#006FF5",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1031 24.1177H30.6958",
    stroke: "#006FF5",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1031 28.5294H25.8316",
    stroke: "#006FF5",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1031 32.9412H22.2939",
    stroke: "#006FF5",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13.1231,
    y: 11,
    width: 20.5524,
    height: 28,
    rx: 1,
    stroke: "#006FF5",
    strokeWidth: 2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1463 32.719L28.2486 31.9943C28.2804 31.7697 28.3875 31.5625 28.5525 31.4069L40.0392 20.5699C40.6212 20.0207 41.5298 20.018 42.1153 20.5637C42.7443 21.1499 42.7612 22.141 42.1526 22.7482L36.899 27.9896L30.4853 33.6774C30.276 33.8631 29.9984 33.9525 29.72 33.924L29.0346 33.8537C28.4703 33.7959 28.0669 33.2807 28.1463 32.719Z",
    fill: "#BFDBFD",
    stroke: "#006FF5",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0908 21.5688L40.761 23.2352",
    stroke: "#006FF5",
    strokeWidth: 2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9049 25V25C41.6061 25.7773 41.5431 26.9744 40.7642 27.6737L37.7936 30.341",
    stroke: "#006FF5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContract);
export default __webpack_public_path__ + "static/media/contract.2a3b7ddc97424ce50d6d68e43b43a465.svg";
export { ForwardRef as ReactComponent };